import styled from "styled-components";
import headerBG from "../../../../../assets/images/robobg.jpg";


export const SalePageContainer = styled.div.attrs((props: any) => ({
    backgroundImg: props.backgroundImg || false,
}))`
    width: 100%;
    padding: 0 10%;
    padding-top: 2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    ${props => props.backgroundImg && `
        background-image: url(${props.backgroundImg});
        background-size: cover;
        background-position: 50% 50%;
    `}
    min-height: 100%;

    ${({ theme }) => theme.mediaWidth.upToMedium`
        padding: 0 1rem;
    `}
`;

export const SalePageCounter = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-bottom: 1rem;
    background: ${({ theme }) => theme.newBg2};
    border-radius: 0.5rem;
    padding: 0.5rem;
    box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.3);
`;

export const SalePageHeader = styled.div.attrs((props: any) => ({
    fontFamily: props.fontFamily || null,
}))`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 0.5rem;
    min-height: 270px;
    box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.3);
    background-image: url(${headerBG});
    background-size: cover;
    background-position: 50% 50%;
    
    //background: linear-gradient(90deg, #7a798a, #7f7793, #88749a, #956f9e, #a4699f, #b4619b, #c55894, #d44e89, #e2427a, #ed3767, #f42f52, #f82d3a);
    > * {
        flex: 1;
        text-align: center;
        font-family: ${props => props.fontFamily ? props.fontFamily + "," : ""} 'Nunito', 'Inter var', sans-serif;
    }
`;

export const SalePageContent = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    flex: 1;
    margin-top: 1rem;
    ${({ theme }) => theme.mediaWidth.upToLarge`
        flex-direction: column;
    `}
`;

export const SalePageCards = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.pageBg}80;
    border-radius: 0.5rem;
    box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.3);
    padding: 1rem;
    margin-bottom: 1rem;
    position: relative;
    min-height: 550px;
    overflow: hidden;
    &:first-child {
        margin-right: 0.5rem;
    }
    &:last-child {
        margin-left: 0.5rem;
    }
`;

export const SalePageDetail = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1rem;
`;

export const SalePageMint = styled.div`
    height: 200px;
    margin: 1rem 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;

    h1 {
        margin: 0.5rem;
    }
`;

export const SalePageDescription = styled.div.attrs((props: any) => ({
    fontFamily: props.fontFamily || null,
    backgroundImg: props.backgroundImg || false,
}))`
    width: 100%;
    position: relative;
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    font-size: 1.2rem;
    font-weight: 400;
    color: ${({ theme }) => theme.text2};
    text-align: center;
    font-family: ${props => props.fontFamily ? props.fontFamily + "," : ""} 'Nunito', 'Inter var', sans-serif;
    background-color: ${({ theme }) => theme.pageBg}80;
    box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.3);
    border-radius: 0.5rem;

    > span {
        position: relative;
        //color: #fff;
    }

    ${props => props.backgroundImg && `
        &::before {
            content: "";
            position: absolute;
            top: 0px;
            right: 0px;
            bottom: 0px;
            left: 0px;
            opacity: 0.5;
            background-image: url(${props.backgroundImg});
            background-repeat: no-repeat;
            background-position: 95% 90%;
            background-size: 20%;        
        }
    `}
`;